"use client";

import React from "react";
import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TestingAvailability() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="testingavailability" ref={ref} data-nav="light" className="relative w-full bg-background text-foreground py-16 sm:py-20 lg:py-24 border-t border-border overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)"
      }} className="transition-all duration-700 ease-out">
          <Card className="border border-border/80 bg-card text-card-foreground shadow-sm rounded-2xl p-6 sm:p-10 lg:p-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 -mt-8 -mr-8 w-44 h-44 rounded-full bg-primary/5 blur-2xl pointer-events-none" aria-hidden="true" />
            <div className="absolute bottom-0 left-0 -mb-8 -ml-8 w-44 h-44 rounded-full bg-accent/40 blur-2xl pointer-events-none" aria-hidden="true" />

            <CardContent className="p-0 relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8 lg:gap-12">
              <div className="max-w-2xl space-y-4">
                <div className="inline-flex items-center gap-2 text-primary font-medium text-sm">
                  <MapPin className="size-4 shrink-0" aria-hidden="true" />
                  <span>Clinical Locations</span>
                </div>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-foreground">
                  Where is testing available?
                </h2>
                <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
                  VO₂ Max and RMR testing will be available at selected PhysAnalytica locations. Availability depends on equipment, practitioner and appointment requirements.
                </p>
              </div>

              <div className="shrink-0 flex items-center">
                <Button size="lg" className="w-full sm:w-auto font-medium shadow-sm hover:shadow transition-shadow" asChild>
                  <Link to="#">
                    Ask About Testing Availability
                    <ArrowRight className="size-4" aria-hidden="true" />
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}